import { OPEN as t } from "@partoohub/api-client";
const o = (e) => e ? !!(e?.status === t && e?.opening_date && new Date(e?.opening_date) > /* @__PURE__ */ new Date()) : !1;
export {
  o as isBusinessOpeningSoon
};
